export const FLIGHT_LIST = "FLIGHT_LIST";
export const FLIGHT_SEARCH_FILTER = "FLIGHT_SEARCH_FILTER";
export const FILTERED_FLIGHT_LIST = "FILTERED_FLIGHT_LIST";
export const FILTERED_FILTER_ITEMS = "FILTERED_FILTER_ITEMS";
export const FILTER_TIMES = "FILTER_TIMES";
export const CLEAR_SEARCH_DATA = "CLEAR_SEARCH_DATA";
export const COUNTRY_LIST = "COUNTRY_LIST";
export const BUSY_CALLERS_CHANGE = "BUSY_CALLERS_CHANGE";
export const HOLDED_FLIGHT_ITEM = "HOLDED_FLIGHT_ITEM";
export const DOMESTIC_RETURN_HOLDED_FLIGHT_ITEM = "DOMESTIC_RETURN_HOLDED_FLIGHT_ITEM";
export const HOLDED_FLIGHT_RESPONSE = "HOLDED_FLIGHT_RESPONSE";
export const FLIGHT_SEARCH_FORM = "FLIGHT_SEARCH_FORM";
export const PLAIN_SEARCH_FORM = "PLAIN_SEARCH_FORM"
export const IS_FLIGHT_SEARCHING = "IS_FLIGHT_SEARCHING";

// TOURS
export const DESTINATION_OPTIONS = "DESTINATION_OPTIONS";
